import HeaderButton from './HeaderButton'
import { Box, styled, useMediaQuery, useTheme } from '@mui/material'
import { Delivery } from 'types'
import { useNavigate, useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { useDeliveriesService } from '../../../../../../services'
import { DetailsPageHeader } from '../../../../components/DetailsPageHeader/DetailsPageHeader'

const HeaderContainer = styled(Box)`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;
`

const TitleRenderWrapper = styled(Box)`
  background: ${({ theme }) => theme.palette.background.default};
  border-radius: 8px;
  box-shadow: 0 3px 0 0 #0000000d;
  flex: 1;
  height: 100%;
`

type HeaderProps = {
  delivery?: Delivery
  toggleNirResults: (
    deliveryId: string,
    deliveryName: string,
    deliveryDate: string
  ) => void
}

export const Header = ({ delivery, toggleNirResults }: HeaderProps) => {
  const navigate = useNavigate()
  const { deliveryId } = useParams()
  const { getThinDeliveryById, getDeliveries } = useDeliveriesService()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('lg'))

  const { data: incomingDeliveries } = useQuery({
    queryKey: ['incoming_deliveries'],
    queryFn: () => getDeliveries(),
  })

  const incomingDeliveryIds = incomingDeliveries?.results?.map(
    (delivery) => delivery.id
  )

  const handleNavigate = async (direction: 'next' | 'prev') => {
    if (!incomingDeliveryIds || incomingDeliveryIds.length === 0) return

    const currentIndex = incomingDeliveryIds.findIndex(
      (id) => id.toString() === deliveryId
    )
    if (currentIndex === -1) return

    const newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1

    if (newIndex < 0 || newIndex >= incomingDeliveryIds.length) return

    const newDeliveryId = incomingDeliveryIds[newIndex]

    try {
      const deliveryData = await getThinDeliveryById(newDeliveryId.toString())

      if (deliveryData?.result.wheat_code_id) {
        navigate(
          `/shipments/incoming-deliveries/${newDeliveryId}/${deliveryData?.result.wheat_code_id}`
        )
      } else {
        toggleNirResults(
          newDeliveryId.toString(),
          deliveryData?.result?.nir?.nir_number?.toString(),
          deliveryData?.result?.nir?.arrival_date
        )
      }
    } catch (error) {
      console.error('Error fetching delivery data:', error)
    }
  }

  return (
    <HeaderContainer
      sx={{
        fontSize: isMediumScreen ? 12 : 14,
      }}
    >
      {!isSmallScreen && (
        <HeaderButton onClick={() => handleNavigate('prev')}>
          {isMediumScreen ? 'Previous' : 'Previous NIR results'}
        </HeaderButton>
      )}
      <TitleRenderWrapper>
        <DetailsPageHeader delivery={delivery} />
      </TitleRenderWrapper>
      {!isSmallScreen && (
        <HeaderButton onClick={() => handleNavigate('next')}>
          {isMediumScreen ? 'Next' : 'Next NIR results'}
        </HeaderButton>
      )}
    </HeaderContainer>
  )
}
